import type {Readable} from 'svelte/store';
import {getContext, hasContext, setContext} from 'svelte';
import {writable} from 'svelte/store';

const pageContextKey = 'page-ctx-key';

interface PageDataContext<STATIC, REACTIVE> {
    staticData: STATIC,
    reactiveData: Readable<REACTIVE>,
    updateReactiveData: (data: REACTIVE) => void
}

export function createPageContext<STATIC_DATA, REACTIVE_DATA = unknown>(staticData: STATIC_DATA = undefined, reactiveData?: REACTIVE_DATA): PageDataContext<STATIC_DATA, REACTIVE_DATA> {
    const reactiveDataStore = writable<REACTIVE_DATA>(reactiveData);

    return setContext<PageDataContext<STATIC_DATA, REACTIVE_DATA>>(pageContextKey, {
        staticData,
        reactiveData: reactiveDataStore,
        updateReactiveData: (data) => reactiveDataStore.set(data)
    });
}

export function getPageContext<STATIC_DATA, REACTIVE_DATA = unknown>(): PageDataContext<STATIC_DATA, REACTIVE_DATA> {
    if (!hasContext(pageContextKey)) {
        throw new Error('Page context does not exist! Use `createPageContext` function to create it in a parent component.');
    }

    return getContext<PageDataContext<STATIC_DATA, REACTIVE_DATA>>(pageContextKey);
}